export default "https://cdn-static.gokick.com/assets/5330764b9b84e4374a94f4eff9433164072ac9e6/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";